
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindApparent14 as ObiWindApparent14Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-apparent-14.js';
 
 
 

 
 export const ObiWindApparent14 = createComponent({
   react: React,
   tagName: 'obi-wind-apparent-14',
   elementClass: ObiWindApparent14Element,
   events: {
     
   }
  });
 
 